import Form from 'mobx-react-form';
import { muiFormBindings } from 'forms/utils/muiFormBindings';
import { plugins } from 'forms/utils/formPlugins';
import { FieldsDefinitions } from 'mobx-react-form/lib/models/FormInterface';
import { userProfile, userSettings } from 'utils/labels';
import { formOptions } from 'forms/utils/formOptions';
import { isEmail, isRequired } from 'forms/utils/validators';

export function createForm(validationConfig: { isInternal: boolean } = { isInternal: false }) {
  const fields: FieldsDefinitions = [
    {
      name: 'fullName',
      label: userProfile.fullName,
      bindings: 'TextField',
      value: '',
      validators: [...(!validationConfig?.isInternal ? [isRequired] : [])],
    },
    {
      name: 'email',
      label: userProfile.email,
      bindings: 'TextField',
      value: '',
      validators: [isRequired, isEmail],
    },
    {
      name: 'jobRole',
      label: userProfile.jobRole,
      bindings: 'AutoCompleteTextField',
      value: '',
      validators: [...(!validationConfig?.isInternal ? [isRequired] : [])],
    },
    {
      name: 'companyName',
      label: userProfile.companyName,
      bindings: 'AutoCompleteTextField',
      // eslint-disable-next-line no-restricted-syntax
      value: null,
      validators: [...(!validationConfig?.isInternal ? [isRequired] : [])],
    },
    {
      name: 'hasCostarLicense',
      label: userSettings.hasCostarLicense,
      bindings: 'Checkbox',
      value: false,
    },
  ];

  return new Form(
    { fields },
    {
      plugins,
      bindings: muiFormBindings,
      options: formOptions,
    }
  );
}
